<template>
  <div class="nav">
    <h3>广告计划</h3>
    <ul>
      <li>推广目标</li>
    </ul>
    <h3>广告</h3>
    <ul>
      <li v-for="item,index in adList" :key="index">{{item.title}}</li>
    </ul>
    <h3>创意</h3>
    <ul>
      <li v-for="item,index in idea"  :key="index">{{item.title}}</li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      adList: [
        {
          title: "广告详情"
        },
        {
          title: "用户定向"
        },
        {
          title: "预算与出价"
        },
        {
          title: "广告名称"
        }
      ],
      idea: [{ title: "上传创意" }, { title: "上传广告资源" }]
    };
  }
};
</script>
<style scoped>
  .nav{
    width: 200px;
    height: calc(100% - 80px);
    background: #FFFFFF;
    box-shadow: 0 0 0px 0 rgba(0,0,0,0.10);
    padding-top: 40px;
    padding-left: 60px;
    position: fixed;
    top: 80px;
    left: 0;
  }
  .nav h3{
    font-size: 18px;
    color: #424753;
  }
  .nav ul{
    margin-bottom: 40px;
    font-size: 14px;
    color: #424753;
  }
  .nav ul li{
    height: 20px;
    line-height: 20px;
    margin: 3px 0;
    opacity: 0.6;
  }
</style>




// WEBPACK FOOTER //
// src/components/nav2.vue